<template>
  <div class="container">
    <div class="developing">developing</div>
    <div class="btn">
      <el-button type="primary" @click="jumpMobile">访问手机端页面</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'developIng',

  methods: {
    jumpMobile() {
      // 使用Vue Router跳转到/mobile路径
      this.$router.push('/mobile');
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.developing{
  text-align: center;
  font-size: 2rem;
  color: #606266;
  background: #f5f7fa;
  margin-bottom: 0;
}

.btn {
  margin-top: 0;
}
</style>